import { UserWorkLog } from '../../../types/apiDomain';

const getWorktimeAmountFromUserWorkLogs = (workLogs: UserWorkLog[] | undefined) => {
    let amount = 0;

    workLogs?.forEach((workLog) => {
        amount += workLog.minutes / 60;
    });

    return amount;
};

export default getWorktimeAmountFromUserWorkLogs;
